import React, {useState} from "react";
import {useDispatch} from "react-redux";

const WhatsHappening = () => {
  let [whatsHappening, setWhatsHappening] = useState('');
  const dispatch = useDispatch();
  const tweetClickHandler = () => {
    let url = 'https://enigmatic-fortress-23182.herokuapp.com/api/tweets';
    fetch(url, {
      method: 'POST',
      body: JSON.stringify({tweet: whatsHappening}),
      headers: {
        "Content-Type": "application/json"
      }
    })
    .then(response => response.json())
    .then(tweet => dispatch({
          type: 'create-tweet',
          tweet
        })
    );
  }
  return(
    <>
      <table style={{marginBottom: '16px'}}>
        <tbody>
        <tr>
          <td style={{verticalAlign: 'top'}}>
            <img className="rounded-circle wd-avatar-image"
                 src={"../../../images/elon.jpg"}
                 alt={"avatar_image"}
                 style={{width: '48px', margin: '16px'}}/>
          </td>
          <td style={{width: "100%"}}>
            <textarea value={whatsHappening}
              onChange={(event) =>
                  setWhatsHappening(event.target.value)}
                      className="form-control"
                      style={{width: "100%", color: "white",
                        padding: "0px",
                        paddingTop: "15px",
                        backgroundColor: "black"}}
                      placeholder="What's happening?"></textarea>
            <hr/>
            <span>
                <a href="#top"><i className="far fa-image me-3"></i></a>
                <a href="#top"><i className="fas fa-chart-line me-3" ></i></a>
                <a href="#top"><i className="far fa-smile me-3"></i></a>
                <a href="#top"><i className="far fa-calendar me-3"></i></a>
            </span>
            <button className={"btn btn-primary fa-pull-right rounded-pill "} onClick={tweetClickHandler}>
              Tweet
            </button>
          </td>
        </tr>
        </tbody>
      </table>
    </>
  );
}
export default WhatsHappening;
